module.exports = __webpack_public_path__ + "static/img/theme_3.cf56b864.png";